import { Box, Stack, Typography } from "@mui/material";

const chartTitleSx = {
  fontSize: "0.95rem",
  fontWeight: 700,
  textTransform: "uppercase",
};

/**
 * Shared title row for pricing aggregate table and card grid (matches chart block title styling).
 */
export default function AggregateResultsHeader({ title, subtitle, headerActions }) {
  const hasSubtitle = Boolean(subtitle?.trim());

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      gap={1}
      sx={{ mb: 1.5 }}
    >
      <Box>
        <Typography sx={chartTitleSx}>{title}</Typography>
        {hasSubtitle ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle.trim()}
          </Typography>
        ) : null}
      </Box>
      {headerActions ? <Box>{headerActions}</Box> : null}
    </Stack>
  );
}
